import { useSessionStorage } from "nid-common";

export const useAccountSessionStorage = <T>(key: string, initialValue: T) => {
  return useSessionStorage(`account-${key}`, initialValue);
};
